import { Box, styled } from "@mui/material";

export const Rows = styled(Box)`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

export const Row = styled(Box)`
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    gap: 8px;
    > button {
        align-self: center;
    }
`;
